import React, { useState, useEffect } from 'react'

import { Button, Grid, Dialog, Collapse, Icon, Typography } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { PostDataAPI } from '../../../../Services/APIService';
import { getFormatedDate } from '../../../../components/Common/Extensions';
import { DraggableComponent, Label } from '../../../../components/UiElements/UiElements';
import { InputBaseField } from '../../../../components/InputField/InputField';
import moment from 'moment';
import { withSnackbar } from "../../../../components/Message/Alert";
import useStyles from "./styles";

function DateFilters({generateReport, dialogOpenClose, handleClose, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    const getDefaultFromDate = () => {
        const now = new Date();
        const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, now.getHours(), now.getMinutes(), now
            .getSeconds());
        return firstDayOfMonth.toISOString().split('T')[0];
    };
    
    const [state, setState] = useState({ fromDate: getDefaultFromDate(), toDate: new Date().toISOString().split('T')[0] });



    const handleSelectfilter = () => {
        if (!state.fromDate) {
            showMessage("Error", "Please select from date", "error", 3000);
            return;
        }
        else if (!state.toDate) {
            showMessage("Error", "Please select to date", "error", 3000);
            return;
        }
        else if (state.fromDate > state.toDate) {
            showMessage("Error", "From date cannot be greater than to date", "error", 3000);
            return;
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const fromDate = new Date(state.fromDate);
        fromDate.setHours(0, 0, 0, 0);

        const toDate = new Date(state.toDate);
        toDate.setHours(0, 0, 0, 0);

        if (fromDate > today && toDate > today) {
            showMessage("Error", "From Date and To Date both can't be from future", "error", 3000);
            return;
        }
        else {
            generateReport(state);
        }
    }

   
    
    const handleChange = (e) => {
        const { name, value, checked } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: value,

        }));
    }
    useEffect(() => {
 
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Usage Report</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
   

                        <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>
                            <div className={classes.content}>
                               
                                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >
                                    <div className="d-flex">

                                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >
                                            <Grid container className="d-flex1">
                                                <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                                                    <Label title="From" style={{ margin: '0px 0px 0px 0px' }} />
                                                </Grid>
                                                <Grid item xl={10} lg={10} md={10} sm={10} xs={10} >
                                                    <InputBaseField
                                                        name="fromDate"
                                                        placeholder="From Date"
                                                        type="date"
                                                        value={state.fromDate}
                                                        onChange={handleChange}  />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Grid container className="d-flex1 ">
                                                <Grid item xl={2} lg={2} md={2} sm={2} xs={2} >
                                                    <Label title="To" />
                                                </Grid>
                                                <Grid item xl={10} lg={10} md={10} sm={10} xs={10} >
                                                    <InputBaseField
                                                        name="toDate"
                                                        placeholder="To Date"
                                                        type="date"
                                                        value={state.toDate}
                                                        onChange={handleChange} 
                                                        />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                     

                                    </div>
                                </Grid>

                            </div>
                        </Scrollbars>

                    <div className={classes.footer}>

                        <div className={classes.footerRight}>
                            <Button className={classes.changeBtn} onClick={handleSelectfilter}>Select</Button>
                            <Button className={classes.changeBtn} onClick={() => handleClose()}>Close</Button>

                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(DateFilters)